export const DIN_BELUT_STORY = "Anda adalah Din Belut, penangkap hantu tersohor di negeri Pahang. Anda menerima aduan gangguan pelbagai hantu yang nakal, di Kampung Sanggang. Buktikan anda bukanlah kaki sembang!";

export const LOADING_STAGES = [
  "Din Belut sedang bersiap",
  "Pokok-pokok sedang ditanam",
  "Hantu-hantu sedang mendengar taklimat",
  "Din Belut OTW ...",
  "Action!",
] as const;

export interface LoadingUpdate { readonly progress: number; readonly message: string; }

export class WeightedLoadingProgress {
  private readonly completed = new Map<string, number>();
  constructor(private readonly weights: Readonly<Record<string, number>>) {}
  complete(task: string): number { if (this.weights[task] !== undefined) this.completed.set(task, this.weights[task]!);return this.value; }
  get value(): number { const total=Object.values(this.weights).reduce((sum,value)=>sum+value,0);const done=[...this.completed.values()].reduce((sum,value)=>sum+value,0);return total===0?1:Math.min(1,done/total); }
}

export interface LoadingScreenActions { onEnter: () => void; onRetry: () => void; onCancel: () => void; }

export class LoadingScreen {
  private typeTimer?: number;
  private ready = false;
  private entered = false;

  constructor(private readonly root: HTMLElement, private readonly actions: LoadingScreenActions) {}

  show(): void {
    this.root.innerHTML=`<main class="screen intro-screen">
      <div class="mist mist-a"></div><div class="mist mist-b"></div>
      <section class="intro-layout">
        <figure class="intro-portrait"><img src="./assets/Din Belut.png" alt="Din Belut, penangkap hantu" draggable="false"></figure>
        <article class="intro-card glass-panel">
          <p class="eyebrow">PENANGKAP HANTU · KAMPUNG SANGGANG</p>
          <h2>KISAH DIN BELUT</h2>
          <p class="intro-story" id="intro-story" aria-label="${DIN_BELUT_STORY}"></p>
          <div class="loading-status" aria-live="polite"><div class="loading-track"><i id="loading-fill"></i></div><div><span id="loading-message">${LOADING_STAGES[0]}</span><b id="loading-percent">0%</b></div></div>
          <div class="intro-actions"><button class="back intro-cancel">← Menu Utama</button><button class="primary enter-forest" disabled>MASUK HUTAN</button></div>
          <div class="loading-error" id="loading-error" role="alert"></div>
        </article>
      </section>
    </main>`;
    this.root.querySelector(".enter-forest")?.addEventListener("click",()=>{if(!this.ready||this.entered)return;this.entered=true;this.stopTypewriter();this.actions.onEnter();});
    this.root.querySelector(".intro-cancel")?.addEventListener("click",()=>{this.stopTypewriter();this.actions.onCancel();});
    this.startTypewriter();
  }

  update({progress,message}:LoadingUpdate):void {
    const normalized=Math.max(0,Math.min(1,progress));
    const fill=this.root.querySelector<HTMLElement>("#loading-fill");if(fill)fill.style.width=`${Math.round(normalized*100)}%`;
    const percent=this.root.querySelector<HTMLElement>("#loading-percent");if(percent)percent.textContent=`${Math.round(normalized*100)}%`;
    const label=this.root.querySelector<HTMLElement>("#loading-message");if(label)label.textContent=message;
  }

  markReady():void {
    this.ready=true;this.update({progress:1,message:LOADING_STAGES[4]});
    const button=this.root.querySelector<HTMLButtonElement>(".enter-forest");if(button){button.disabled=false;button.classList.add("ready");}
  }

  showError(message="Hutan gagal disiapkan. Cuba sekali lagi."):void {
    this.ready=false;
    const error=this.root.querySelector<HTMLElement>("#loading-error");if(error)error.innerHTML=`<p>${message}</p><button class="primary retry-loading">CUBA SEMULA</button>`;
    this.root.querySelector(".retry-loading")?.addEventListener("click",()=>{this.stopTypewriter();this.actions.onRetry();},{once:true});
  }

  dispose():void { this.stopTypewriter(); }

  private startTypewriter():void {
    const node=this.root.querySelector<HTMLElement>("#intro-story");if(!node)return;
    if(matchMedia("(prefers-reduced-motion: reduce)").matches){node.textContent=DIN_BELUT_STORY;return;}
    let index=0;const tick=()=>{if(!node.isConnected)return;index=Math.min(DIN_BELUT_STORY.length,index+2);node.textContent=DIN_BELUT_STORY.slice(0,index);if(index<DIN_BELUT_STORY.length)this.typeTimer=window.setTimeout(tick,24);};tick();
  }
  private stopTypewriter():void { if(this.typeTimer!==undefined)window.clearTimeout(this.typeTimer);this.typeTimer=undefined; }
}
